import { axiosInstance } from './../config';

export const betMedia = {
  toggleEvent(eventId: string) {
		return axiosInstance.post(`/administration/live/bet_media/activate/${eventId}`).then((res) => res.data);
	}
}